import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import { useTranslate } from 'ra-core'
import { useRecordContext } from 'react-admin'
import { RadioButtonGroupInput, required } from 'react-admin'
import { useWatch } from 'react-hook-form'

import {
  ActionCommentSection,
  ActionModalSection,
  IncidentReportActionDialog,
  REJECT_I18N_PREFIX,
  REJECTION_REASON_CHOICES,
  REJECTION_REASON_LABELS,
  useActionSubmit,
} from './common'
import { INCIDENT_REPORT_ACTION_REJECT, INCIDENT_REPORT_REJECTION_REASON_OTHER } from '../../../config/damages'

const RejectReasonInput = () => (
  <ActionModalSection
    titleKey={`${REJECT_I18N_PREFIX}.reasonTitle`}
    titleIcon={HighlightOffIcon}
    helperKey={`${REJECT_I18N_PREFIX}.reasonHelper`}
  >
    <RadioButtonGroupInput
      source="rejection_reason"
      choices={REJECTION_REASON_CHOICES}
      helperText={false}
      label={false}
      optionValue="id"
      row={false}
      translateChoice={true}
      validate={required()}
    />
  </ActionModalSection>
)

const RejectCommentInput = () => {
  const reason = useWatch({ name: 'rejection_reason' })
  const isOtherReason = reason === INCIDENT_REPORT_REJECTION_REASON_OTHER

  return (
    <ActionCommentSection
      titleKey={`${REJECT_I18N_PREFIX}.commentTitle`}
      helperKey={`${REJECT_I18N_PREFIX}.${isOtherReason ? 'commentHelperOther' : 'commentHelper'}`}
      placeholderKey={`${REJECT_I18N_PREFIX}.${isOtherReason ? 'commentPlaceholderOther' : 'commentPlaceholder'}`}
      isRequired={isOtherReason}
    />
  )
}

export const RejectDamageReportFormDialog = ({ open, onClose }) => {
  const record = useRecordContext()
  const translate = useTranslate()
  const [submitAction, isLoading] = useActionSubmit(record.id, onClose)
  const onSubmitAction = (values) =>
    submitAction(
      INCIDENT_REPORT_ACTION_REJECT,
      {
        comment: `${translate(REJECTION_REASON_LABELS[values.rejection_reason] || values.rejection_reason)}${
          values.comment ? `: ${values.comment}` : ''
        }`,
      },
      `${REJECT_I18N_PREFIX}.success`,
    )

  return (
    <IncidentReportActionDialog
      open={open}
      onClose={onClose}
      isLoading={isLoading}
      i18nPrefix={REJECT_I18N_PREFIX}
      formProps={{ mode: 'onChange' }}
      footerProps={{
        confirmLabelKey: `${REJECT_I18N_PREFIX}.confirmLabel`,
        confirmColor: 'error',
        confirmVariant: 'contained',
        onSubmitAction,
      }}
    >
      <RejectReasonInput />
      <RejectCommentInput />
    </IncidentReportActionDialog>
  )
}
